import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ChronosHttp } from "src/app/security/chronos-http";
import { NomeDTO } from "src/app/shared/models/nome";
import { VendedorDTO } from "src/app/shared/models/vendedor";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SellerService {
  url: string;

  constructor(private http: ChronosHttp) {
    this.url = `${environment.apiUrl}/cadastros/comercial/vendedores`;
  }

  //EndPoint Vendedor

  findAll(idempresa: number): Promise<Array<VendedorDTO>> {
    const params = new HttpParams().set("idempresa", idempresa.toString());
    return this.http
      .get<Array<VendedorDTO>>(`${this.url}/empresa`, {
        params: params,
      })
      .toPromise();
  }

  findById(idVendedor: number): Promise<VendedorDTO> {
    const params = new HttpParams().set("id", idVendedor.toString());
    return this.http
      .get<VendedorDTO>(`${this.url}/${idVendedor}`, {
        params: params,
      })
      .toPromise();
  }

  findByName(name: string, idempresa: number): Promise<Array<NomeDTO>> {
    const params = new HttpParams({
      fromObject: {
        filter: name,
        idempresa: idempresa.toString(),
      },
    });

    return this.http
      .get<Array<NomeDTO>>(`${this.url}/nome`, { params: params })
      .toPromise();
  }

  findByEmail(email: string): Promise<VendedorDTO> {
    const params = new HttpParams({
      fromObject: {
        filter: email,
      },
    });

    return this.http
      .get<VendedorDTO>(`${this.url}/login`, { params: params })
      .toPromise();
  }
}
